import React from "react";
import { useTranslation } from "react-i18next";
import "./lawyers.css";

// title/lead come from the shared SEO copy (copy.lawyers), so the heading
// matches what the server renders for crawlers.
export default function Heading(props) {
  const { t } = useTranslation();
  return (
    <section className="avc-page-hero">
      <div className="container avc-page-hero__inner">
        <span className="avc-eyebrow">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
          {t("lawyers_eyebrow")}
        </span>
        <h1 className="avc-page-hero__title">{props.title}</h1>
        <p className="avc-page-hero__lead">{props.lead}</p>
        {props.children}
      </div>
    </section>
  );
}
